import { useCurrentClient } from '@/composables/useCurrentClient'
import { defineNuxtRouteMiddleware, useCookie } from 'nuxt/app'

/** Перед защищёнными маршрутами — гарантировать X-Client-Id в последующих запросах. */
export default defineNuxtRouteMiddleware(async (to) => {
  if (to.meta.public || to.meta.systemContext) return

  const token = useCookie('access_token')
  if (!token.value) return

  if (process.client && localStorage.getItem('is_system') === '1') return

  const { init } = useCurrentClient()
  await init()
})
